import * as types from './mutation-types'

export default {
  [types.SET_FLAGS] (state, flags) {
    state.flags = flags
  },
  [types.SET_DADOS_RETORNO_CADASTRO] (state, dadosRetornoDoCadastro) {
    state.dadosRetorno = {
      sucesso: dadosRetornoDoCadastro.sucesso,
      mensagem: dadosRetornoDoCadastro.mensagem,
      listaDeErros: dadosRetornoDoCadastro.listaDeErros
    }
  },
  [types.SET_CARREGANDO_DADOS] (state, { status, mensagem }) {
    state.flagsDeControle.carregandoDados.status = status
    state.flagsDeControle.carregandoDados.mensagem = mensagem
  },
  [types.SET_MANIPULANDO_DADOS] (state, { status, mensagem }) {
    state.flagsDeControle.manipulandoDados.status = status
    state.flagsDeControle.manipulandoDados.mensagem = mensagem
  }
}
